















































































































































































































































































































































































































































































































































































































































/* eslint-disable no-param-reassign */
/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import FormTextInput from '@/components/shared/FormTextInput.vue';
import LayerConfig from '@/models/map-context/LayerConfig';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import BaseComponent from '../../BaseComponent';
import ColorPalette from '@/models/ColorPalette';
import LayerIndicators from '@/models/map-context/LayerIndicators';
import ColorPalettePanel from '@/components/shared/ColorPalettePanel.vue';
import Indicator, { IndicatorAggregationType } from '@/models/map-context/Indicator';
import LayerAttribute from '@/models/map-context/LayerAttribute';
import FormNumberInput from '@/components/shared/FormNumberInput.vue';
import FormComboInput from '@/components/shared/FormComboInput.vue';
import FormHtmlEditor from '@/components/shared/FormHtmlEditor.vue';

@Component({
  props: {
    layer: LayerConfig,
  },
  components: {
    FormTextInput,
    ColorPalettePanel,
    FormHtmlEditor,
    FormNumberInput,
    FormComboInput,
  },
})
export default class IndicatorInfos extends BaseComponent {
  layer!: LayerConfig;

  newIndic = false;

  showAdvanced = false;

  attribute: LayerAttribute | null = null;

  attributelabel: LayerAttribute | null = null;

  valueAttribute: LayerAttribute | null = null;

  aggregationType: IndicatorAggregationType = 'count';

  centerUnit = '';

  showCenterObjetDatas = false;

  useColorFromAnalyse = false;

  nbColors = 10;

  label = '';

  labelManual = false;

  colorPalette: ColorPalette | null = null;

  colorPalettes: ColorPalette[] = [];

  indicators = new LayerIndicators();

  textContent = '';

  textSelectContent = '';

  graphType = '';

  topCount = 5;

  dragIndex: number | null = null;

  dragOverIndex: number | null = null;

  graphTypeTiles = [
    {
      value: 'distinct_donut',
      title: 'Donut',
      hint: 'Répartition par valeurs distinctes',
    },
    {
      value: 'minmaxmean',
      title: 'Barres',
      hint: 'Min / max / moyenne',
    },
    {
      value: 'top_n',
      title: 'Top X',
      hint: 'Objets aux plus grandes valeurs',
    },
    {
      value: 'textarea',
      title: 'Texte',
      hint: 'Stats personnalisées',
    },
  ];

  aggregationTypes = [
    { text: 'Nombre d\'objets', value: 'count' },
    { text: 'Somme', value: 'sum' },
    { text: 'Moyenne', value: 'mean' },
  ];

  presets = [
    {
      id: 'count_by_category',
      label: 'Répartition par catégorie',
      shortLabel: 'Répartition',
    },
    {
      id: 'sum_by_category',
      label: 'Somme par catégorie',
      shortLabel: 'Somme',
    },
    {
      id: 'stats_numeric',
      label: 'Stats (min / max / moy.)',
      shortLabel: 'Stats',
    },
    {
      id: 'top_n',
      label: 'Top objets',
      shortLabel: 'Top X',
    },
  ];

  get hasIndicators(): boolean {
    return !!(this.indicators && this.indicators.indicators && this.indicators.indicators.length);
  }

  get attributeOptions(): LayerAttribute[] {
    return this.layer.layerProperties || [];
  }

  get numericAttributeOptions(): LayerAttribute[] {
    const props = this.attributeOptions;
    const numeric = props.filter((attr) => this.isNumericAttribute(attr));
    return numeric.length > 0 ? numeric : props;
  }

  get attributeFieldLabel(): string {
    return this.graphType === 'distinct_donut' ? 'Grouper par' : 'Attribut de valeur';
  }

  get attributeFieldHint(): string {
    if (this.graphType === 'distinct_donut') {
      return 'Une part du donut = une valeur de cet attribut.';
    }
    if (this.graphType === 'minmaxmean' || this.graphType === 'textarea') {
      return 'Attribut numérique sur lequel calculer min, max, moyenne et total.';
    }
    if (this.graphType === 'top_n') {
      return 'Attribut numérique utilisé pour classer les objets (du plus grand au plus petit).';
    }
    return '';
  }

  get indicatorSummary(): string {
    if (!this.graphType || !this.attribute) {
      return '';
    }
    const draft = this.buildDraftIndicator();
    return draft ? draft.getSummary() : '';
  }

  get canAlignAnalyse(): boolean {
    return this.graphType === 'distinct_donut'
      && this.layer.complexStyle
      && this.layer.complexStyle.isDefined();
  }

  get colorAnalyseWarning(): string {
    if (!this.useColorFromAnalyse || this.graphType === 'textarea' || !this.attribute) {
      return '';
    }
    if (!this.layer.complexStyle || !this.layer.complexStyle.isDefined()) {
      return '';
    }
    const colorRules = this.getColorRules();
    const attr = this.attribute.name;
    const mentionsAttr = colorRules.some((rule: any) =>
      (rule.value && String(rule.value).indexOf(attr) >= 0)
      || (rule.label && String(rule.label).indexOf(attr) >= 0)
    );
    if (!mentionsAttr && this.graphType === 'distinct_donut') {
      return `Attention : l'analyse thématique ne semble pas basée sur « ${attr} ».`;
    }
    return '';
  }

  get canAddIndicator(): boolean {
    if (!this.newIndic || !this.graphType || !this.attribute || !this.attributelabel) {
      return false;
    }
    const needsValueAttribute = this.graphType === 'distinct_donut' && this.aggregationType !== 'count';
    if (needsValueAttribute && !this.valueAttribute) {
      return false;
    }
    if (this.graphType === 'top_n' && (!this.topCount || this.topCount < 1)) {
      return false;
    }
    const needsPalette = this.graphType !== 'textarea' && !this.useColorFromAnalyse;
    if (needsPalette && !this.colorPalette) {
      return false;
    }
    return true;
  }

  get addBlockedReason(): string {
    if (!this.graphType) {
      return 'Choisissez un type de visualisation.';
    }
    if (!this.attribute) {
      return this.graphType === 'distinct_donut'
        ? 'Choisissez un attribut pour grouper les données.'
        : 'Choisissez un attribut de valeur.';
    }
    if (this.graphType === 'distinct_donut' && this.aggregationType !== 'count' && !this.valueAttribute) {
      return 'Choisissez l\'attribut numérique à sommer ou moyenner.';
    }
    if (!this.attributelabel) {
      return 'Choisissez l\'attribut servant de nom d\'objet (label).';
    }
    if (this.graphType !== 'textarea' && !this.useColorFromAnalyse && !this.colorPalette) {
      return 'Choisissez une palette, ou activez les couleurs de l\'analyse.';
    }
    return '';
  }

  get previewReady(): boolean {
    return !!this.graphType && !!this.attribute;
  }

  get previewFromData(): boolean {
    return this.getPreviewFeatures().length > 0;
  }

  get previewDonutSlices(): Array<{ title: string; value: number; color: string }> {
    const stats = this.computePreviewStats();
    if (!Array.isArray(stats) || !stats.length) {
      return this.schematicDonutSlices();
    }
    const colors = this.getPreviewColors(stats.length);
    return stats.slice(0, 6).map((stat: any, i: number) => ({
      title: String(stat.title !== undefined ? stat.title : ''),
      value: Number(stat.value !== undefined ? stat.value : stat.count) || 0,
      color: stat.color || colors[i % colors.length],
    }));
  }

  get previewExtraCount(): number {
    const stats = this.computePreviewStats();
    if (!Array.isArray(stats) || stats.length <= 6) {
      return 0;
    }
    return stats.length - 6;
  }

  get previewTruncated(): boolean {
    return this.previewExtraCount > 0;
  }

  get previewDonutGradient(): string {
    const slices = this.previewDonutSlices;
    const total = slices.reduce((sum, s) => sum + (Number(s.value) || 0), 0) || 1;
    let cursor = 0;
    const parts = slices.map((slice) => {
      const start = (cursor / total) * 360;
      cursor += Number(slice.value) || 0;
      const end = (cursor / total) * 360;
      return `${slice.color} ${start}deg ${end}deg`;
    });
    return `conic-gradient(${parts.join(', ')})`;
  }

  get previewBars(): Array<{ label: string; value: number | string; pct: number; color: string }> {
    const stats = this.computePreviewStats();
    const colors = ['#5b8def', '#3cb371', '#e67e22'];
    if (!stats || Array.isArray(stats)) {
      return [
        { label: 'Min', value: '—', pct: 30, color: colors[0] },
        { label: 'Moy', value: '—', pct: 55, color: colors[1] },
        { label: 'Max', value: '—', pct: 90, color: colors[2] },
      ];
    }
    const max = Math.max(Number(stats.max) || 0, 1);
    return [
      { label: 'Min', value: stats.min, pct: Math.max(8, (Number(stats.min) / max) * 100), color: colors[0] },
      { label: 'Moy', value: stats.mean, pct: Math.max(8, (Number(stats.mean) / max) * 100), color: colors[1] },
      { label: 'Max', value: stats.max, pct: 100, color: colors[2] },
    ];
  }

  get previewTopNRows(): Array<{ label: string; value: string | number; color: string }> {
    const stats = this.computePreviewStats();
    const colors = this.getPreviewColors(5);
    if (!Array.isArray(stats) || !stats.length) {
      return [
        { label: 'Objet A', value: '…', color: colors[0] },
        { label: 'Objet B', value: '…', color: colors[1] },
        { label: 'Objet C', value: '…', color: colors[2] },
      ];
    }
    return stats.slice(0, Math.max(1, Number(this.topCount) || 5)).map((row: any, i: number) => ({
      label: String(row.label || 'Sans nom'),
      value: row.value,
      color: row.color || colors[i % colors.length],
    }));
  }

  get previewTextHtml(): string {
    const draft = this.buildDraftIndicator();
    if (!draft) {
      return '<em>Renseignez un attribut pour prévisualiser.</em>';
    }
    const features = this.getPreviewFeatures();
    if (features.length) {
      draft.computeStats(features, this.layer);
      return draft.currentTextContent || draft.replaceContent(draft.textContent || 'Min {MIN} — Max {MAX} — Moy. {MEAN} ({COUNT} objets)', draft.stats);
    }
    return (this.textContent || 'Min {MIN} — Max {MAX} — Moy. {MEAN} ({COUNT} objets)')
      .replace(/\{MIN\}/g, '…')
      .replace(/\{MAX\}/g, '…')
      .replace(/\{MEAN\}/g, '…')
      .replace(/\{COUNT\}/g, '…');
  }

  @Watch('graphType')
  onGraphTypeChange() {
    this.applySmartDefaults();
    this.refreshAutoTitle();
  }

  @Watch('attribute')
  onAttributeChange() {
    this.refreshAutoTitle();
  }

  @Watch('aggregationType')
  onAggregationTypeChange() {
    if (this.aggregationType !== 'count' && !this.valueAttribute) {
      this.valueAttribute = this.suggestNumericAttribute();
    }
    this.refreshAutoTitle();
  }

  @Watch('valueAttribute')
  onValueAttributeChange() {
    this.refreshAutoTitle();
  }

  @Watch('topCount')
  onTopCountChange() {
    this.refreshAutoTitle();
  }

  mounted() {
    this.colorPalettes = this.contextService.colorPalettes;
    if (this.layer.indicators) {
      this.indicators = this.layer.indicators;
    }
  }

  getColorRules(): any[] {
    if (!this.layer.complexStyle) {
      return [];
    }
    if (typeof this.layer.complexStyle.getColorRules === 'function') {
      return this.layer.complexStyle.getColorRules();
    }
    return this.layer.complexStyle.styleRules || [];
  }

  attributeOptionLabel(attr: LayerAttribute): string {
    if (!attr) {
      return '';
    }
    return `${attr.name} (${this.getTypeLabel(attr)})`;
  }

  getTypeLabel(attr: LayerAttribute): string {
    if (this.isNumericAttribute(attr)) {
      return 'nombre';
    }
    if (typeof attr.isDate === 'function' && attr.isDate()) {
      return 'date';
    }
    if (typeof attr.isBoolean === 'function' && attr.isBoolean()) {
      return 'booléen';
    }
    if (typeof attr.isText === 'function' && attr.isText()) {
      return 'texte';
    }
    const local = (attr.localType || attr.type || 'texte').replace(/^xsd:/, '');
    return local || 'texte';
  }

  isNumericAttribute(attr: LayerAttribute): boolean {
    if (!attr) {
      return false;
    }
    if (typeof attr.isNumber === 'function' && attr.isNumber()) {
      return true;
    }
    const type = `${attr.type || ''} ${attr.localType || ''}`.toLowerCase();
    return type.indexOf('int') >= 0
      || type.indexOf('number') >= 0
      || type.indexOf('double') >= 0
      || type.indexOf('float') >= 0
      || type.indexOf('decimal') >= 0
      || type.indexOf('long') >= 0;
  }

  selectGraphType(value: string) {
    this.graphType = value;
  }

  suggestLabelAttribute(): LayerAttribute | null {
    const props = this.attributeOptions;
    if (!props.length) {
      return null;
    }
    const preferredNames = ['name', 'nom', 'label', 'title', 'libelle', 'libellé'];
    const byName = props.find((attr) => preferredNames.indexOf(String(attr.name).toLowerCase()) >= 0);
    if (byName) {
      return byName;
    }
    const textAttr = props.find((attr) =>
      (typeof attr.isText === 'function' && attr.isText()) || !this.isNumericAttribute(attr)
    );
    return textAttr || props[0];
  }

  suggestNumericAttribute(): LayerAttribute | null {
    const numeric = this.numericAttributeOptions;
    if (!numeric.length) {
      return null;
    }
    return numeric[0];
  }

  suggestMainAttribute(): LayerAttribute | null {
    const props = this.attributeOptions;
    if (!props.length) {
      return null;
    }
    if (this.graphType === 'distinct_donut') {
      return props.find((attr) => !this.isNumericAttribute(attr)) || props[0];
    }
    if (this.graphType === 'top_n' || this.graphType === 'minmaxmean' || this.graphType === 'textarea') {
      return this.suggestNumericAttribute() || props[0];
    }
    return this.suggestNumericAttribute() || props[0];
  }

  guessAttributeFromAnalyse(): string | null {
    const rules = this.getColorRules();
    for (let i = 0; i < rules.length; i += 1) {
      const value = String(rules[i].value || '');
      const match = value.match(/([A-Za-z_][\w]*)\s*(=|<>|!=|IN|LIKE|ILIKE|~)/i);
      if (match && match[1]) {
        return match[1];
      }
    }
    return null;
  }

  alignToAnalyse() {
    const attrName = this.guessAttributeFromAnalyse();
    if (attrName) {
      const found = this.layer.getLayerPropertieByName(attrName);
      if (found) {
        this.attribute = found;
      }
    }
    this.useColorFromAnalyse = true;
    this.showAdvanced = true;
    this.refreshAutoTitle();
  }

  buildAutoTitle(): string {
    if (!this.graphType || !this.attribute) {
      return '';
    }
    if (this.graphType === 'distinct_donut') {
      if (this.aggregationType === 'count') {
        return `Nombre par ${this.attribute.name}`;
      }
      const calc = this.aggregationType === 'sum' ? 'Somme' : 'Moyenne';
      const valueName = this.valueAttribute ? this.valueAttribute.name : 'valeur';
      return `${calc} ${valueName} par ${this.attribute.name}`;
    }
    if (this.graphType === 'minmaxmean') {
      return `Min / max / moyenne — ${this.attribute.name}`;
    }
    if (this.graphType === 'textarea') {
      return `Stats — ${this.attribute.name}`;
    }
    if (this.graphType === 'top_n') {
      const n = this.topCount || 5;
      return `Top ${n} — ${this.attribute.name}`;
    }
    return '';
  }

  refreshAutoTitle() {
    if (this.labelManual) {
      return;
    }
    this.label = this.buildAutoTitle();
  }

  regenerateTitle() {
    this.labelManual = false;
    this.label = this.buildAutoTitle();
  }

  onLabelInput(value: string) {
    this.label = value;
    this.labelManual = true;
  }

  applySmartDefaults() {
    if (!this.attributelabel) {
      this.attributelabel = this.suggestLabelAttribute();
    }
    if (!this.attribute) {
      this.attribute = this.suggestMainAttribute();
    } else if (this.graphType === 'minmaxmean' || this.graphType === 'textarea' || this.graphType === 'top_n') {
      if (!this.isNumericAttribute(this.attribute)) {
        this.attribute = this.suggestNumericAttribute();
      }
    }
    if (this.graphType === 'top_n' && (!this.topCount || this.topCount < 1)) {
      this.topCount = 5;
    }
    if (this.graphType === 'distinct_donut' && this.aggregationType !== 'count' && !this.valueAttribute) {
      this.valueAttribute = this.suggestNumericAttribute();
    }
    if (!this.colorPalette && this.colorPalettes.length > 0) {
      this.colorPalette = this.colorPalettes.find((p) => p.name === 'Indicateurs')
        || this.colorPalettes.find((p) => p.name === 'Spectral')
        || this.colorPalettes[0];
    }
    if (this.graphType === 'textarea' && !this.textContent) {
      this.textContent = '<p><strong>{COUNT}</strong> objets — min {MIN}, max {MAX}, moy. {MEAN}</p>';
    }
  }

  resetForm() {
    this.graphType = '';
    this.attribute = null;
    this.attributelabel = null;
    this.valueAttribute = null;
    this.aggregationType = 'count';
    this.centerUnit = '';
    this.topCount = 5;
    this.showCenterObjetDatas = false;
    this.useColorFromAnalyse = false;
    this.nbColors = 10;
    this.label = '';
    this.labelManual = false;
    this.colorPalette = null;
    this.textContent = '';
    this.textSelectContent = '';
    this.showAdvanced = false;
  }

  startNewIndicator() {
    this.resetForm();
    this.newIndic = true;
  }

  cancelNewIndicator() {
    this.newIndic = false;
    this.resetForm();
  }

  applyPreset(presetId: string) {
    this.resetForm();
    this.newIndic = true;
    this.showAdvanced = false;
    if (presetId === 'count_by_category') {
      this.graphType = 'distinct_donut';
      this.aggregationType = 'count';
    } else if (presetId === 'sum_by_category') {
      this.graphType = 'distinct_donut';
      this.aggregationType = 'sum';
    } else if (presetId === 'stats_numeric') {
      this.graphType = 'minmaxmean';
    } else if (presetId === 'top_n') {
      this.graphType = 'top_n';
      this.topCount = 5;
    }
    this.$nextTick(() => {
      this.applySmartDefaults();
      if (presetId === 'sum_by_category') {
        this.valueAttribute = this.suggestNumericAttribute();
      }
      if (this.canAlignAnalyse && (presetId === 'count_by_category' || presetId === 'sum_by_category')) {
        const analyseAttr = this.guessAttributeFromAnalyse();
        if (analyseAttr) {
          const found = this.layer.getLayerPropertieByName(analyseAttr);
          if (found) {
            this.attribute = found;
            this.useColorFromAnalyse = true;
          }
        }
      }
      this.labelManual = false;
      this.refreshAutoTitle();
    });
  }

  buildDraftIndicator(): Indicator | null {
    if (!this.graphType || !this.attribute) {
      return null;
    }
    const indic = new Indicator();
    indic.graphType = this.graphType;
    indic.attributeName = this.attribute.name;
    indic.labelAttribute = this.attributelabel ? this.attributelabel.name : this.attribute.name;
    indic.aggregationType = this.aggregationType;
    indic.valueAttribute = this.valueAttribute ? this.valueAttribute.name : undefined;
    indic.useColorFromAnalyse = this.useColorFromAnalyse;
    indic.colorPalette = this.colorPalette ? this.colorPalette.name : '';
    indic.nbColors = this.nbColors;
    indic.textContent = this.textContent || '<p>Min {MIN} — Max {MAX} — Moy. {MEAN} ({COUNT})</p>';
    indic.centerUnit = this.centerUnit;
    indic.topCount = this.topCount || 5;
    return indic;
  }

  getPreviewFeatures(): any[] {
    try {
      const source = this.layer.getLayerSource && this.layer.getLayerSource();
      if (!source || typeof source.getFeatures !== 'function') {
        return [];
      }
      const features = source.getFeatures() || [];
      return features.slice(0, 500);
    } catch (e) {
      return [];
    }
  }

  computePreviewStats(): any {
    const draft = this.buildDraftIndicator();
    if (!draft) {
      return null;
    }
    const features = this.getPreviewFeatures();
    if (!features.length) {
      return null;
    }
    draft.computeStats(features, this.layer);
    return draft.stats;
  }

  schematicDonutSlices() {
    const colors = this.getPreviewColors(4);
    return [
      { title: 'A', value: 40, color: colors[0] },
      { title: 'B', value: 25, color: colors[1] },
      { title: 'C', value: 20, color: colors[2] },
      { title: 'D', value: 15, color: colors[3] },
    ];
  }

  getPreviewColors(count: number): string[] {
    const safe = Math.max(count, 1);
    if (this.colorPalette) {
      try {
        return this.getColorPalette(this.colorPalette).getColors(safe);
      } catch (e) {
        // fallback below
      }
    }
    return ['#4e79a7', '#f28e2b', '#e15759', '#76b7b2', '#59a14f', '#edc949'].slice(0, safe);
  }

  changeAttributeName(indic: Indicator, attribute: LayerAttribute) {
    if (attribute) {
      indic.attributeName = attribute.name;
    }
  }

  changeAttributeLabel(indic: Indicator, attribute: LayerAttribute) {
    if (attribute) {
      indic.labelAttribute = attribute.name;
    }
  }

  changeValueAttribute(indic: Indicator, attribute: LayerAttribute) {
    indic.valueAttribute = attribute ? attribute.name : undefined;
  }

  onColorChange(indic: Indicator, value: any) {
    if (value && value.name) {
      indic.colorPalette = value.name;
    }
  }

  getSelectedColorPalette(paletteName?: string) {
    if (!paletteName) {
      return null;
    }
    return this.colorPalettes.find((palette) => palette.name === paletteName) || null;
  }

  addIndicator() {
    if (!this.canAddIndicator || !this.attribute || !this.attributelabel) {
      return;
    }
    const needsValueAttribute = this.graphType === 'distinct_donut' && this.aggregationType !== 'count';
    const indic = new Indicator();
    indic.attributeName = this.attribute.name;
    indic.labelAttribute = this.attributelabel.name;
    indic.label = this.label || this.buildAutoTitle();
    indic.graphType = this.graphType;
    indic.showCenterObject = this.showCenterObjetDatas;
    indic.useColorFromAnalyse = this.useColorFromAnalyse;
    indic.active = true;
    if (this.graphType === 'distinct_donut') {
      indic.aggregationType = this.aggregationType;
      indic.valueAttribute = needsValueAttribute && this.valueAttribute
        ? this.valueAttribute.name
        : undefined;
      indic.centerUnit = this.centerUnit ? this.centerUnit.trim() : undefined;
    }
    if (this.graphType === 'top_n') {
      indic.topCount = Math.max(1, Number(this.topCount) || 5);
      indic.centerUnit = this.centerUnit ? this.centerUnit.trim() : undefined;
    }
    if (this.graphType === 'textarea') {
      indic.textContent = this.textContent;
      indic.textSelectContent = this.textSelectContent;
    } else if (this.colorPalette) {
      indic.colorPalette = this.colorPalette.name;
      indic.nbColors = this.nbColors;
    }
    if (!this.layer.indicators) {
      this.layer.indicators = new LayerIndicators();
      this.indicators = this.layer.indicators;
    }
    this.layer.indicators.indicators.push(indic);
    this.cancelNewIndicator();
  }

  getColorPalette(x: any) {
    return new ColorPalette(x);
  }

  toggleEdit(rule: Indicator) {
    rule.edit = !rule.edit;
    if (rule.edit) {
      rule.showAdvanced = false;
    }
  }

  toggleVisible(rule: Indicator) {
    rule.active = !rule.isVisible();
  }

  duplicateIndic(rule: Indicator) {
    const copy = rule.clone();
    copy.label = `${rule.label || 'Indicateur'} (copie)`;
    copy.edit = false;
    copy.showAdvanced = false;
    copy.active = true;
    const index = this.layer.indicators.indicators.indexOf(rule);
    this.layer.indicators.indicators.splice(index + 1, 0, copy);
  }

  removeIndic(rule: Indicator) {
    const title = rule.label || rule.getSummary() || 'cet indicateur';
    if (!window.confirm(`Supprimer « ${title} » ?`)) {
      return;
    }
    const ruleIndex = this.layer.indicators.indicators.indexOf(rule);
    if (ruleIndex >= 0) {
      this.layer.indicators.indicators.splice(ruleIndex, 1);
    }
  }

  onDragStart(event: DragEvent, index: number) {
    this.dragIndex = index;
    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/plain', String(index));
    }
  }

  onDragOver(_event: DragEvent, index: number) {
    this.dragOverIndex = index;
  }

  onDrop(targetIndex: number) {
    if (this.dragIndex === null || this.dragIndex === targetIndex) {
      this.onDragEnd();
      return;
    }
    const list = this.layer.indicators.indicators;
    const [moved] = list.splice(this.dragIndex, 1);
    list.splice(targetIndex, 0, moved);
    this.onDragEnd();
  }

  onDragEnd() {
    this.dragIndex = null;
    this.dragOverIndex = null;
  }
}
